import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Row, Col, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import BaseUrl from '../base-api';
import Loader from './Loader/Loader';
import { useLocation } from 'react-router-dom';

const GalleryPage = () => {
    const [imagesGallery, setImagesGallery] = useState([]);
    const [loading, setLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const location = useLocation();
    const lang = location.pathname.startsWith('/en') ? 'en' : 'hi';

    const fetchGalleryImages = useCallback(async () => {
        setLoading(true); // Start loading
        try {
            const res = await axios.post(
                `${BaseUrl}/api/v1/files/getImages`,
                { location: "Photo Gallery" },
                {
                    headers: { "Content-Type": "application/json" },
                    timeout: 100000,
                }
            );

            const content = res?.data?.data?.content;

            if (res.data.status === 200 && Array.isArray(content)) {
                const processedImages = content.map((img, index) => ({
                    src: img.file ? `data:image/jpeg;base64,${img.file}` : "",
                    key: img.key || index + 1,
                }));
                setImagesGallery(processedImages);
            } else {
                toast.error("Image format ठीक नहीं है");
            }

        } catch (error) {
            console.error("Gallery images failed:", error);
            toast.error("Gallery images load नहीं हो सके");
        } finally {
            setLoading(false); // Stop loading
        }
    }, []);

    useEffect(() => {
        fetchGalleryImages();
    }, [fetchGalleryImages]);

    const handleImageClick = (src) => {
        setPreviewImage(src);
    };

    const closePreview = () => {
        setPreviewImage(null);
    };

    return (
        <div className="container py-4">
            <h3 className="text-center font-weight-bold mb-4">
                {lang === 'en' ? 'Gallery' : 'गैलरी'}
            </h3>

            {/* Fullscreen Preview */}
            {previewImage && (
                <div
                    onClick={closePreview}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                        cursor: 'default',
                    }}
                >
                    <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                            maxWidth: '90%',
                            maxHeight: '90%',
                            borderRadius: '8px',
                            boxShadow: '0 0 30px rgba(255, 255, 255, 0.3)',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <Button
                        color="danger"
                        onClick={closePreview}
                        style={{
                            position: 'absolute',
                            top: '20px',
                            right: '20px',
                            fontSize: '1.5rem',
                            borderRadius: '50%',
                            padding: '0.2rem 0.6rem',
                        }}
                    >
                        ✕
                    </Button>
                </div>
            )}

            {loading ? (
                <Loader />
            ) : imagesGallery.length === 0 ? (
                <p className="text-center">
                    {lang === 'en' ? 'No images available.' : 'कोई तस्वीर उपलब्ध नहीं है।'}
                </p>
            ) : (
                <Row>
                    {imagesGallery.map((image, index) => (
                        <Col sm="6" md="4" lg="3" key={index} className="mb-4">
                            <div
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: '250px',
                                    overflow: 'hidden',
                                    borderRadius: '8px',
                                }}
                            >
                                <img
                                    src={image.src}
                                    alt={`Gallery Image ${index + 1}`}
                                    onClick={() => handleImageClick(image.src)}
                                    loading="lazy"
                                    style={{
                                        height: '100%',
                                        width: '100%',
                                        objectFit: 'cover',
                                        cursor: 'pointer',
                                        transition: 'transform 0.2s ease-in-out, filter 0.3s',
                                        filter: 'blur(5px)',
                                    }}
                                    onLoad={(e) => {
                                        e.currentTarget.style.filter = 'none';
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.03)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                    }}
                                />
                            </div>
                        </Col>
                    ))}
                </Row>
            )}
        </div>
    );
};

export default GalleryPage;
